<template>
  <Transition name="confirm-overlay">
    <div
      v-if="state.visible"
      class="confirm-overlay"
      @click.self="close(false)"
    >
      <div class="confirm-modal" role="dialog" aria-modal="true">
        <div class="confirm-head">
          <h3>{{ state.title }}</h3>
          <button
            class="btn btn-sm btn-outline-secondary"
            type="button"
            @click="close(false)"
          >
            <span class="fas fa-times"></span>
          </button>
        </div>
        <div class="confirm-body">
          <p>{{ state.message }}</p>
        </div>
        <div class="confirm-actions">
          <button
            class="btn btn-outline-secondary"
            type="button"
            @click="close(false)"
          >
            {{ state.cancelText }}
          </button>
          <button
            class="btn"
            :class="`btn-${state.variant}`"
            type="button"
            @click="close(true)"
          >
            {{ state.confirmText }}
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  inject: ["confirmState", "confirmClose"],
  computed: {
    state() {
      return this.confirmState;
    },
  },
  methods: {
    close(result) {
      this.confirmClose(result);
    },
  },
};
</script>
